/**
 * @module api-web:clientServe/sellManage/apiOrder
 * @description API订单 —— 列表 / 详情 / 审核驳回
 */
import service from '@/service'

/**
 * API订单 列表查询
 * @param {{
 *  orderCode:string,
 *  platformCode:string,
 *  clientName:string,
 *  page:number,
 *  limit:number,
 *  sort:string
 * }} data
 */
export async function getList(data) {
  const res = await service['api-web']({
    url: '/sell/order/apiOrder/getList',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
  // 该接口分页返回 MyBatis-Plus 的 records 结构，而 CRUD mixin 统一读取 data.list，
  // 在这里做一次适配（不改变原有返回体，仅补一个 list 别名）
  const page = res?.data
  if (page && Array.isArray(page.records)) {
    page.list = page.records
  }
  return res
}

/**
 * API订单 详情
 * @param {(string|number)} id
 */
export function info(id) {
  return service['api-web']({
    url: '/sell/order/apiOrder/apiOrderInfo',
    method: 'get',
    params: { id }
  })
}

/**
 * 审核驳回
 * @param {object} data
 */
export function reject(data) {
  return service['api-web']({
    url: '/public/activiti/apiOrderInfo/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
